import PropTypes from 'prop-types';
import StudentRepository from '../services/StudentRepository.js';

export default function CollegeQuestions({
  repo,
  handleScreenNext,
  handleScreenBack,
  handleErrors,
  formValues,
  setFormValues,
  college,
  collegeMap,
  onSkip,
}) {
  if (college in collegeMap) {
    const ScreenClass = collegeMap[college];
    return (
      <ScreenClass
        key="screen_7"
        repo={repo}
        handleScreenNext={handleScreenNext}
        handleScreenBack={handleScreenBack}
        handleErrors={handleErrors}
        formValues={formValues}
        setFormValues={setFormValues}
        onSkip={onSkip}
      />
    );
  }
}

CollegeQuestions.propTypes = {
  repo: PropTypes.instanceOf(StudentRepository),
  studentId: PropTypes.string,
  college: PropTypes.string,
  collegeMap: PropTypes.object,
  handleScreenNext: PropTypes.func,
  handleScreenBack: PropTypes.func,
  handleErrors: PropTypes.func,
  formValues: PropTypes.object,
  setFormValues: PropTypes.func,
  onSkip: PropTypes.func,
};
